import React from 'react';
import { Button, Modal } from 'components';
import { FiAlertTriangle } from 'react-icons/fi';

export const ConfirmationModal = ({
  isOpen,
  customModal,
  customModalBody,
  headerText,
  headerTextStyle,
  infoText,
  acceptText,
  cancelText,
  acceptAction,
  cancelAction,
  blockScroll = false,
  icon,
  deleteIcon,
  children,
  btnColor = '',
  onOverlayClick,
  isAcceptDisabled,
  isCancelDisabled,
}) => {
  deleteIcon ? (btnColor = 'danger') : (btnColor = 'primary');
  return (
    <Modal
      isOpen={isOpen}
      blockScroll={blockScroll}
      onOverlayClick={onOverlayClick}
      classNames={customModal && customModal}
    >
      <div className={`lf-modal-success__container ${customModalBody ? customModalBody : ''}`}>
        {icon ? icon : <FiAlertTriangle className="lf-modal-warning__icon mb-5x" />}
        <h5 className={`lf-text-center lf-text-medium pb-4x ${headerTextStyle ? headerTextStyle : ''}`}>
          {headerText}
        </h5>
        {infoText && <p className="lf-text-center mb-6x">{infoText}</p>}
        {/* <p className="lf-text-center mb-6x">{infoText}</p> */}
        {children}
        <div className="d-flex">
          {acceptText && (
            <Button
              danger={deleteIcon && true}
              primary={!deleteIcon && true}
              clickHandler={acceptAction}
              className="mr-4x"
              disabled={isAcceptDisabled}
            >
              {acceptText}
            </Button>
          )}
          {cancelText && (
            <Button secondary clickHandler={cancelAction} disabled={isCancelDisabled}>
              {cancelText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
